




































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class SiteInfo extends Vue {
    iidpSecure: any = '';
    mounted() {
        const iidpSecureUrl = IIDPconfig.SECURE_URL as string;
        this.iidpSecure = `${iidpSecureUrl}/${IIDPconfig.SECURE_URL_INVESTIGATOR_LOGIN as string}`;
    }
}
